/* eslint-disable */
jQuery('.PageNews .wp-block-post').each(function() {
  var $this = jQuery(this),
      $href = $this.find('.rt-reading-time'),
      $hrefButton = $this.find('.wp-block-post-excerpt__more-text'),
      $target = $this.find('.wp-block-post-date');
      
      $href.appendTo($target);
      $hrefButton.insertAfter($target);
});